"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComEdEsriPageConfig = void 0;
const core_api_1 = require("@ikegps/core-api");
const icons_1 = require("../../components/icon/icons");
const i18n_1 = require("../../i18n");
const page_1 = require("../page");
exports.ComEdEsriPageConfig = {
    type: 'external',
    name: page_1.IkePageName.comedEsri,
    path: 'https://ikegps.maps.arcgis.com/apps/instant/basic/index.html?appid=5d2823ffa29945bc9dc48b296c0934e6',
    auth: {
        required: true,
        tokens: [core_api_1.IkeToken.FEATURE_COMED_MAP_LINK],
    },
    layout: { banner: false },
    nav: {
        name: i18n_1.T.MULTI_ORG_MAP,
        icon: icons_1.MaterialIcon.PUBLIC,
    },
};
//# sourceMappingURL=comed.esri.page.js.map